import { z } from "zod";
import { defineControl, placeholderFieldSchema } from "./field.js";
export const singleLineText = defineControl({
    key: "singleLineText",
    label: "Single line text field",
    schema: placeholderFieldSchema("singleLineText"),
    answer: z.string(),
    isClearable: true,
    empty: { placeholder: "", required: false },
});
